




















import { mapActions } from 'vuex';
import LoadingSpinner from '@reciprocity/loading-spinner';
import { getRequest } from '../../utils/client/client';

export default {
  name: 'RiskAllocation',
  components: {
    LoadingSpinner,
  },
  props: {},
  data() {
    return {
      loading: true,
      tenantId: null,
    };
  },
  created() {
    this.setPageTitle({ title: 'Risk Allocation', visible: false });
    this.fetchHealthDeep();
  },
  methods: {
    ...mapActions({
      setPageTitle: 'setPageTitle',
    }),
    fetchHealthDeep() {
      getRequest({ url: '/health/lite' }).then(responseData => {
        /*eslint-disable */
        const { deployment_id } = responseData;
        this.tenantId = deployment_id;
        /*eslint-enable */
        this.loading = false;
      });
    },
  },
};
